export const AUTH_ERROR_CODES = [
  'AUTH_INVALID_CREDENTIALS',
  'AUTH_ACCOUNT_DISABLED',
  'AUTH_ACCOUNT_LOCKED',
  'AUTH_INVALID_REFRESH_TOKEN',
] as const;

export type AuthErrorCode = (typeof AUTH_ERROR_CODES)[number];

export type ApiErrorSeverity = 'info' | 'success' | 'warning' | 'error';

export interface ApiErrorEnvelope {
  error: {
    code: string;
    message: string | string[];
    severity?: ApiErrorSeverity;
    correlationId?: string;
    details?: Record<string, unknown>;
  };
}

export function isAuthErrorCode(value: unknown): value is AuthErrorCode {
  return typeof value === 'string' && (AUTH_ERROR_CODES as readonly string[]).includes(value);
}
